import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
const BONUSES = [{
  title: 'Bono #1: Libro de Trabajo Diario Reiki',
  value: '$10.990',
  desc: 'Para escribir, integrar y observar tu proceso día a día.',
  image: 'https://cdn.magicpatterns.com/uploads/cU6QtkHADjGewcTcfb9i5j/ChatGPT_Image_5_feb_2026,_16_27_39.png'
}, {
  title: 'Bono #2: Guía de los 7 Chakras',
  value: '$10.990',
  desc: 'Un mapa claro y profundo para comprender tu energía y tu vida.',
  image: 'https://cdn.magicpatterns.com/uploads/mPA2kCP5kMsjuSqckjavJr/ChatGPT_Image_5_feb_2026,_16_27_43.png'
}, {
  title: 'Bono #3: Guía de Meditación Reiki',
  value: '$10.990',
  desc: '20 prácticas para el silencio, sanación y presencia consciente.',
  image: 'https://cdn.magicpatterns.com/uploads/7hwrV91Bq2UzdZrtpbqcQi/ChatGPT_Image_5_feb_2026,_16_48_24.png'
}];
export function BonusesSection() {
  return <section className="py-24 px-4 bg-dark-bg-alt relative overflow-hidden" data-id="element-43">
      <div className="max-w-6xl mx-auto relative z-10" data-id="element-44">
        <div className="text-center mb-16" data-id="element-45">
          <motion.span initial={{
          opacity: 0,
          scale: 0.8
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} className="inline-block bg-gradient-to-r from-yellow-400 to-orange-500 text-black font-bold px-4 py-2 rounded-full mb-6" data-id="element-46">
            🎁 BONUS EXCLUSIVOS
          </motion.span>
          <h2 className="text-4xl md:text-5xl font-display font-bold text-white mb-4" data-id="element-47">
            ¡GRATIS con tu compra!
          </h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-48">
            Solo por tiempo limitado, llevate estos bonus valorados en más de
            $30.000
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16" data-id="element-49">
          {BONUSES.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-dark-surface border border-white/10 rounded-2xl overflow-hidden group hover:border-violet-500/50 transition-all flex flex-col" data-id="element-50">
              {/* Image Container */}
              <div className="relative aspect-[4/5] w-full bg-dark-bg overflow-hidden" data-id="element-51">
                <div className="absolute inset-0 bg-gradient-to-t from-dark-surface to-transparent z-10 opacity-60" data-id="element-52" />
                <a href="https://pay.hotmart.com/O103704589E" target="_blank" rel="noopener noreferrer" onClick={() => {
              if ((window as any).fbq) {
                ;
                (window as any).fbq('track', 'InitiateCheckout', {
                  content_name: 'Reiki MegaPack',
                  content_category: 'Curso Online',
                  value: 19990,
                  currency: 'CLP'
                });
              }
            }} className="block w-full h-full" data-id="element-53">
                  <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700" data-id="element-54" />
                </a>
              </div>

              <div className="p-6 flex-1 flex flex-col" data-id="element-55">
                <div className="flex justify-between items-start mb-4" data-id="element-56">
                  <span className="gratis-badge" data-id="element-57">GRATIS</span>
                  <span className="text-gray-500 line-through text-sm" data-id="element-58">
                    Valor: {bonus.value}
                  </span>
                </div>
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-59">
                  {bonus.title}
                </h3>
                <p className="text-gray-400 text-sm" data-id="element-60">{bonus.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-61">
          <CTAButton text="¡QUIERO MIS REGALOS!" data-id="element-62" />
        </div>
      </div>
    </section>;
}